import moment from "moment";

import { AvailableAndDisputeBalance } from "./AvailableAndDisputeBalance";
import { InlineTable } from "./InlineTable";
import {
  Badge,
  Card,
  CdsColumn,
  CdsGrid,
  CurrencyDisplay,
  DataLoadingView,
  Select,
} from "../../../components";

import {
  applySecurityMask,
  getCurrencySymbol,
  getPaymentStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../utils";
import { payoutStatus } from "../../../enums";
import { IBalanceTableViewProps } from "./BalanceTable";

export const View = (props: IBalanceTableViewProps) => {
  const activeBalanceCurrencySymbol = props.activeBalance?.currency
    ? getCurrencySymbol(props.activeBalance?.currency)
    : "";

  return (
    <Card className="balance-table--container">
      <CdsGrid>
        <CdsColumn sm={4} md={8} lg={8}>
          <AvailableAndDisputeBalance
            title="Available balance"
            subtitle=""
            navigateButton={
              <div className="flex-container align-items--end">
                <span className="font-ctm--bold text-secondary mr-5">
                  Select Currency{" "}
                </span>
                <Select
                  name="balanceCurrencySelect"
                  label=""
                  placeholder="Select currency"
                  className="font-ctm--bold"
                  showSkeleton={props.isLoadingBalances}
                  hideSkeletonLabel
                  selectItems={props.balances.map((bal) => ({
                    text: `${bal.currency} (${getCurrencySymbol(
                      bal.currency
                    )})`,
                    value: bal.currency,
                    // disabled: tag.is_disabled
                  }))}
                  onChange={(e) =>
                    props.setActiveBalanceCurrency(e.target.value)
                  }
                  value={
                    props.activeBalance?.currency
                    /*|| settings.defaultCurrency */
                  }
                />
              </div>
            }
            data={[
              // {
              //   availableBalance:
              //     props.activeBalance?.available_payout_balance || 0,
              //   ledgerBalance: props.activeBalance?.ledger_payout_balance || 0,
              //   currency_symbol: activeBalanceCurrencySymbol,
              //   description: "Payouts to be made",
              //   reactKey: "payouts",
              // },
              {
                availableBalance:
                  props.activeBalance?.available_wallet_balance || 0,
                ledgerBalance: props.activeBalance?.ledger_wallet_balance || 0,
                currency_symbol: activeBalanceCurrencySymbol,
                description: "Available in Wallet",
                reactKey: "wallet",
              },
              // {
              //   amount: props.activeBalance?.disputeBalance || 0,
              //   currency_symbol: activeBalanceCurrencySymbol,
              //   description: "Disputes",
              // },
            ]}
            // total={{
            //   availableBalance: props.activeBalance
            //     ? props.activeBalance.available_payout_balance +
            //       props.activeBalance.available_wallet_balance
            //     : 0,

            //   ledgerBalance: props.activeBalance
            //     ? props.activeBalance.ledger_payout_balance +
            //       props.activeBalance.ledger_wallet_balance
            //     : 0,
            //   currency_symbol: activeBalanceCurrencySymbol,
            //   description: "Total (Wallet + Payouts)",
            //   reactKey: "balanceTotal",
            // }}
            total={{
              availableBalance: props.activeBalance
                ? props.activeBalance.available_wallet_balance
                : 0,

              ledgerBalance: props.activeBalance
                ? props.activeBalance.ledger_wallet_balance
                : 0,
              currency_symbol: activeBalanceCurrencySymbol,
              description: "Total (Wallet)", // : "Total (Wallet + Payouts)",
              reactKey: "balanceTotal",
            }}
          />
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={8}>
          {props.isLoadingPayouts ? (
            <div className="h-100 flex-container justify-content--center align-items--center bordered b-r-5">
              <DataLoadingView message="Loading payouts..." />
            </div>
          ) : (
            <InlineTable
              title={"Payouts"}
              subtitle={"Funds going out of your SwitchApp account"}
              viewAllUrl={"/balances/payouts"}
              data={props.payouts}
              total={0}
              totalCurrencySymbol={"₦"}
              renderRow={(item) => (
                <>
                  <td>
                    <CurrencyDisplay
                      currencyOrSymbol={getCurrencySymbol(item.currency)}
                      amount={item.amount}
                      amountFontSize={14}
                    />
                  </td>
                  <td>
                    <Badge
                      text={item.status}
                      statusColor={
                        item.status === payoutStatus.successful
                          ? "success"
                          : item.status === payoutStatus.processing
                          ? "secondary"
                          : "danger"
                      }
                      // smallFont
                    />
                  </td>
                  <td>
                    {moment(item.created_at).format("MMM DD, YYYY, hh:mm A")}
                  </td>
                  <td>{item.bank_name}</td>
                  <td>
                    {applySecurityMask(
                      item.account_number,
                      item.account_number.length / 2
                    )}
                  </td>
                </>
              )}
            />
          )}
        </CdsColumn>
      </CdsGrid>

      <div className="row-divider" />

      <CdsGrid>
        <CdsColumn sm={4} md={8} lg={8}>
          <AvailableAndDisputeBalance
            title="Disputes"
            subtitle="Transactions your customers have requested refunds for"
            data={
              [
                // {
                //   amount: 35000,
                //   currency_symbol: "₦",
                //   description: "Flutterwave ",
                // },
                // {
                //   amount: 15000,
                //   currency_symbol: "₦",
                //   description: "Paypal",
                // },
              ]
            }
            total={{
              availableBalance: 0, // props.activeBalance?.disputeBalance || 0,
              ledgerBalance: 0, // props.activeBalance?.disputeBalance || 0,
              currency_symbol: activeBalanceCurrencySymbol,
              description: "Total Disputes",
              reactKey: "disputeTotal",
            }}
          />
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={8}>
          {props.isLoadingTopUps ? (
            <div className="h-100 flex-container justify-content--center align-items--center bordered b-r-5 mt-5">
              <DataLoadingView message="Loading top-ups..." />
            </div>
          ) : (
            <InlineTable
              title={"Top-Ups"}
              subtitle={"Funds added to your SwitchApp account"}
              viewAllUrl={"/balances/top-ups"}
              data={props.topUps}
              total={0}
              totalCurrencySymbol={"₦"}
              renderRow={(item) => {
                const statusIndicator = getPaymentStatusIndicator(item);
                const topUpSourceName =
                  item.bank_trsf_account_name ??
                  item.source_gateway_merchant_name;

                return (
                  <>
                    <td>
                      <CurrencyDisplay
                        currencyOrSymbol={item.currency}
                        amount={item.amount}
                        symbolFontSize={14}
                        amountFontSize={14}
                      />
                    </td>
                    <td>
                      <Badge
                        text={statusIndicator.statusText}
                        statusColor={statusIndicator.statusType}
                      />
                    </td>
                    {/* <td>
                      <span className="bordered pl-5 pr-5 b-r-5 text-teal">
                        {item.gateway_code}
                      </span>
                    </td> */}
                    <td>
                      {moment(item.created_at).format("MMM DD, YYYY, hh:mm A")}
                    </td>
                    <td title={topUpSourceName}>
                      <span className="text-teal">
                        {truncateStringWithEllipsis(topUpSourceName, 15)}
                      </span>
                    </td>
                    {/* <td>{item.tx_ref}</td> */}
                    <td>{item.payment_type}</td>
                  </>
                );
              }}
            />
          )}
        </CdsColumn>
      </CdsGrid>
    </Card>
  );
};
